import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import get from "lodash/get";

import * as router from "react-router-redux";
import Config from "../config";
import { sessionActions, sessionConstants } from "../modules/session";
import * as notifications from "../modules/notifications/actions";
import * as tracker from "../modules/tracker/actions";
import { AuthEvents } from "../modules/tracker/event-names";

import EmailAndPasswordForm from "../components/EmailAndPasswordForm";

// ! this component is no longer used, as it simply redirects to the hello login page
class LoginContainer extends React.PureComponent {
    constructor(props) {
        window.location.replace(`${Config.general().helloBaseUrl}/login`);
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit({ email, password }) {
        this.props.trackEvent(AuthEvents.DID_ATTEMPT_LOGIN, {
            username: email
        });

        this.props.authorizeUser(email, password).then(action => {
            const error = action.errorMessage;
            if (error) {
                this.props.trackEvent(AuthEvents.DID_FAIL_AUTHENTICATION, {
                    reason: error
                });
                return this.props.notifyError(
                    "Sorry, we didn’t recognize that email address and password combination. Care to try that again?"
                );
            } else {
                const redirect =
                    this.props.redirectAfterLogin ||
                    `/team/${action.session.teamId}/dashboard`;
                this.props.trackEvent(AuthEvents.DID_AUTHENTICATE_SUCCESSFULLY);
                return this.props.navigateTo(redirect);
            }
        });
    }

    render() {
        return null; // prevent old login page from rendering while redirect to new page occurrs
        const renderHintContent = () => (
            <Link to="/forgot-password">Forgot Password</Link>
        );
        return (
            <main>
                <EmailAndPasswordForm
                    formHeader="Login"
                    emailAddress={
                        this.props.attemptedEmail || this.props.initialEmail
                    }
                    isLoading={this.props.isLoading}
                    onSubmit={this.handleSubmit}
                    renderHintContent={renderHintContent}
                />
            </main>
        );
    }
}

function mapStateToProps(state) {
    const routerState = state.router.location.state;
    const redirectAfterLogin = get(routerState, "redirectAfterLogin", null);
    const initialEmail = get(routerState, "initialEmail", null);

    const loginPageState = state.session[sessionConstants.LOGIN_PAGE_KEY];
    const attemptedEmail = get(loginPageState, "attemptedEmail", null);
    const isLoading = get(loginPageState, "isLoading", false);

    const isAuthenticated = !state.session.authRequired;

    return {
        isAuthenticated,
        redirectAfterLogin,
        initialEmail,
        attemptedEmail,
        isLoading,
        session: state.session
    };
}

function mapDispatchToProps(dispatch) {
    return {
        navigateTo: path => dispatch(router.replace(path)),
        authorizeUser: (username, password) =>
            dispatch(sessionActions.authorizeUser(username, password)),
        notifyError: errorMessage =>
            dispatch(notifications.notifyError(errorMessage)),
        trackEvent: (eventName, eventProperties) =>
            dispatch(tracker.trackEvent(eventName, eventProperties))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.js